import React from 'react'

import MetaData from './meta-data'
import DailyMonitoring from './daily-monitoring'
import OnpageIssues from './onpage-issues'
import LinkChecker from './link-checker'
import About from './about'

function SeoAudit() {
  return (
    <div className="seo-audit">
      <MetaData />
      <DailyMonitoring />
      <OnpageIssues />
      <LinkChecker />
      <About />
    </div>
  )
}

export default SeoAudit
